// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const PolicyLibraryPage = lazy(() => import('./pages/PolicyLibraryPage'));
const ComplianceTrackingPage = lazy(() => import('./pages/ComplianceTrackingPage'));
const BackgroundChecksPage = lazy(() => import('./pages/BackgroundChecksPage'));
const RegulatoryCompliancePage = lazy(() => import('./pages/RegulatoryCompliancePage'));
const LegalDocumentsPage = lazy(() => import('./pages/LegalDocumentsPage'));

export const ComplianceRoutes: RouteObject = {
  path: 'compliance',
  element: <ModuleGuard moduleId="people.compliance" />,
  handle: { crumb: 'Compliance & Legal' },
  children: [
    { index: true, element: <Navigate to="policy-library" replace /> },
    { path: 'policy-library', element: <PolicyLibraryPage />, handle: { crumb: 'Policy Library' } },
    { path: 'compliance-tracking', element: <ComplianceTrackingPage />, handle: { crumb: 'Compliance Tracking' } },
    { path: 'background-checks', element: <BackgroundChecksPage />, handle: { crumb: 'Background Checks' } },
    { path: 'regulatory-compliance', element: <RegulatoryCompliancePage />, handle: { crumb: 'Regulatory Compliance' } },
    { path: 'legal-documents', element: <LegalDocumentsPage />, handle: { crumb: 'Legal Documents' } },
  ],
};
